export default {
  computed: {
    schemaDaerah2023() {
      const bulan = this.$getDeepObj(this.info, 'bulan') || '';
      const parent = {
        63: 62,
        64: 62,
        66: 65,
        67: 65,
        69: 68,
        70: 68,
      };
      const instrumen = [...[], ...this.listInstrumen['daerah']].map((instrumen) => {
        return Object.assign(
          {},
          parent[instrumen.id]
            ? { exist: { status: +this.form[`instrumen-radio-${parent[instrumen.id]}`] === 161 } }
            : {},
          instrumen,
          {
            label: [65, 68].includes(+instrumen.id)
              ? `${instrumen.label} <span class="grey--text">(opsional)</span>`
              : instrumen.label,
          }
        );
      });

      return {
        dasar: {
          title: 'Gambaran Umum Kegiatan',
          laporan: [
            {
              type: 'textView',
              label: 'Bulan Pelaksanaan',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: bulan || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'VRadio',
              name: 'is_terlaksana',
              label: 'Apakah ada forum PMO level daerah bulan ini?',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              required: true,
              items: [
                { text: 'Ya', value: 1 },
                { text: 'Tidak', value: 0 },
              ],
              grid: { cols: 12, md: 6 },
            },
            {
              disabled: this.isPreview,
              exist: { status: +this.form.is_terlaksana === 1 },
              type: 'VDatePicker',
              name: 'tgl_pelaksanaan',
              label: 'Tanggal Pelaksanaan',
              labelColor: 'indigo',
              usePrependInnerIcon: 'mdi-calendar-month',
              hint: 'wajib diisi',
              required: true,
              outlined: true,
              singleLine: true,
              hideDetails: true,
              dense: true,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              disabled: this.isPreview,
              exist: { status: +this.form.is_terlaksana === 1 },
              type: 'VSelect',
              name: 'k_koordinator_moda_psp',
              label: 'Moda yang diterapkan',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              items: this.$mapForMaster(this.$getDeepObj(this.masters, 'koordinator_moda_psp') || {}),
              outlined: true,
              singleLine: true,
              hideDetails: true,
              readonly: this.readOnly,
              dense: true,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              show: { status: +this.form.is_terlaksana === 1 },
              type: 'cascade',
              labelColor: 'indigo',
              configs: this.configs,
              grid: { cols: 12 },
            },
            {
              disabled: this.isPreview,
              show: { status: +this.form.is_terlaksana === 0 },
              type: 'VSelect',
              name: 'k_koordinator_alasan_psp',
              label: 'Alasan tidak adanya kegiatan',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              items: this.$mapForMaster(this.masters.koordinator_alasan_psp || {}),
              itemText: 'text',
              itemValue: 'value',
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              show: { status: +this.form.is_terlaksana === 0 && +this.form.k_koordinator_alasan_psp === 9 },
              type: 'VTextarea',
              name: 'alasan_lain',
              label: 'Alasan lainnya tidak menyelenggarakan kegiatan',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 2,
              autoGrow: true,
            },
          ],
        },
        peserta: {
          hidden: +this.form.is_terlaksana !== 1,
          title: 'Peserta PMO level daerah',
          laporan: [
            {
              disabled: this.isPreview,
              type: 'VTextField',
              name: 'jml_lpmp',
              label: 'BPMP/BBPMP',
              labelColor: 'indigo',
              hint: '',
              mask: '###',
              required: false,
              outlined: true,
              singleLine: true,
              hideDetail: true,
              dense: true,
              readonly: this.readOnly,
              grid: { cols: 12, md: 3, sm: 12 },
            },
            {
              disabled: this.isPreview,
              type: 'VTextField',
              name: 'jml_bgp',
              label: 'BGP/BBGP',
              labelColor: 'indigo',
              hint: '',
              mask: '###',
              required: false,
              outlined: true,
              singleLine: true,
              hideDetail: true,
              dense: true,
              readonly: this.readOnly,
              grid: { cols: 12, md: 3, sm: 12 },
            },
            {
              disabled: this.isPreview,
              type: 'VTextField',
              name: 'jml_disdik',
              label: 'Dinas Pendidikan',
              labelColor: 'indigo',
              hint: '',
              mask: '###',
              required: false,
              outlined: true,
              singleLine: true,
              hideDetail: true,
              dense: true,
              readonly: this.readOnly,
              grid: { cols: 12, md: 3, sm: 12 },
            },
            {
              disabled: this.isPreview,
              type: 'VTextField',
              name: 'jml_lain',
              label: 'Lainnya',
              labelColor: 'indigo',
              hint: '',
              mask: '###',
              required: false,
              outlined: true,
              singleLine: true,
              hideDetail: true,
              dense: true,
              readonly: this.readOnly,
              grid: { cols: 12, md: 3, sm: 12 },
            },
          ],
        },
        kegiatan: {
          hidden: +this.form.is_terlaksana !== 1,
          trigger: true,
          title: 'Pelaksanaan Kegiatan',
          laporan: instrumen,
        },
      };
    },
  },
};
